import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { addPackagesList, updatePackagesList } from '../../../actions'

const PackageForm = ({ onClose, dataEdit }) => {
    
const BUSINESS_CATEGORIES = [
  { code: 'CAR01', label: 'Spare Parts' },
  { code: 'CAR02', label: 'Garage' },
  { code: 'CAR03', label: 'Car Dealer' },
  { code: 'CAR04', label: 'Rent a Car' },
  { code: 'CAR06', label: 'Car Wash' },
  { code: 'CAR07', label: 'Car Insurance' },
  { code: 'CAR08', label: 'Driving School' },
  { code: 'CAR09', label: 'Car Protection' },
  { code: 'CAR10', label: 'Car Towing' },
  { code: 'CAR11', label: 'Taxi' },
  { code: 'CAR12', label: 'Air Conditioning' },
  { code: 'CAR13', label: 'Quick Service' },
  { code: 'CAR15', label: 'Car Sale' },
]

const [packageForm, setPackageForm] = useState({
  name:'',
  text:'',
  duration:0,
  amount:0,
  status:'',
  businessCode:''
})

const onChangehandler = (e) => {
  const {name, value} = e.target
  setPackageForm({...packageForm, [name]:value})
}
console.log("dataEdit", dataEdit);

const dispatch = useDispatch()

useEffect(() => {
  if(Object.keys(dataEdit).length>0){
    setPackageForm({
      name: dataEdit.name,
      text: dataEdit.text,
      amount: dataEdit.amount,
      duration: dataEdit.duration,
      status: dataEdit.status,
      businessCode: dataEdit.businessCode,
    })
  }
},[dataEdit])

const onSaveHandler = () => {
  if(Object.keys(dataEdit).length > 0){
    const data = {
      advertisementPackId: dataEdit?.advertisementPackId,
      amount: Number(packageForm.amount),
      duration: Number(packageForm.duration),
      text: packageForm.text,
      name: packageForm.name,
      status: packageForm.status,
      businessCode: packageForm.businessCode
    }
    dispatch(updatePackagesList(data))
    onClose(false)
  } else {
    if(!packageForm.businessCode){
      alert('Please select a Business Category')
      return
    }
    const data = {
      amount: Number(packageForm.amount),
      duration: Number(packageForm.duration),
      text: packageForm.text,
      name: packageForm.name,
      status: packageForm.status,
      businessCode: packageForm.businessCode
    }
    dispatch(addPackagesList(data))
    onClose(false)
  }
}
const onCloseHandler = () => {
    onClose(false)
}
  return (
    <div className='main-body'>
      <div className='page-wrapper'>
        <div className='page-header'>
          <div className='row align-items-end'>
            <div className='col-lg-8'>
              <div className='page-header-title'>
                <div className='d-inline'>
                  <h4>
                    { Object.keys(dataEdit).length > 0 ? `Edit : ${dataEdit?.name}` : "Add Package" } 
                  </h4>
                </div>
              </div>
            </div>
                  <div className='col-lg-4'>
                    <div className='page-header-breadcrumb'>
                      <ul className='breadcrumb-title'>
                        <li className='breadcrumb-item'>
                          {/* <Link to='/'> */}
                            <i className='feather icon-home'></i>{' '}
                          {/* </Link> */}
                        </li>
                        <li className='breadcrumb-item'>Packages
                          {/* <Link to='/CarDetail/CarModel'>Packages</Link> */}
                        </li>
                        <li className='breadcrumb-item active'>
                        { Object.keys(dataEdit).length > 0 ? "Edit Package:" : "Add Package" } 
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className='page-body'>
                <div className='row'>
                  <div className='col-sm-12'>
                    <div className='card card-border-default'>
                      <div className='card-block'>
                        
                        <div className='tab-content tabs'>
                          <div
                            className='tab-pane  active'
                            id={'car_user_'}
                            role='tabpanel'
                            aria-labelledby=''>
                              <div className=''>
                  
                        <div className='card-body'>
                          <div className='row'>
                            <div className='col-md-6'>
                              <div className='form-group row'>
                                <label className='col-sm-3 col-form-label'>Business Category</label>
                                <div className='col-sm-9'>
                                  <select
                                    name='businessCode'
                                    value={packageForm?.businessCode}
                                    onChange={onChangehandler}
                                    className='form-control'>
                                    <option value=''>Select Business Category</option>
                                    {BUSINESS_CATEGORIES.map((c) => (
                                      <option key={c.code} value={c.code}>{c.label}</option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div className='col-md-6'>
                              <div className='form-group row'>
                                <label className='col-sm-3 col-form-label'>Package Name</label>
                                <div className='col-sm-9'>
                                  <input
                                    onChange={onChangehandler}
                                    type='text'
                                    className='form-control'
                                    name='name'
                                    value={packageForm?.name}
                                    placeholder='Enter Package Name'
                                    // onChange={onChangeHandle}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className='col-md-6'>
                              <div className='form-group row'>
                                <label className='col-sm-3 col-form-label'>Description</label>
                                <div className='col-sm-9'>
                                <input
                                  onChange={onChangehandler}
                                    type='text'
                                    className='form-control'
                                    name='text'
                                    value={packageForm?.text}
                                    placeholder='Enter Description'
                                    // onChange={onChangeHandle}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className='col-md-6'>
                              <div className='form-group row'>
                                <label className='col-sm-3 col-form-label'>Amount</label>
                                <div className='col-sm-9'>
                                <input
                                  onChange={onChangehandler}
                                    type='number'
                                    className='form-control'
                                    name='amount'
                                    value={packageForm?.amount}
                                    placeholder='Enter Amount'
                                    // onChange={onChangeHandle}
                                  />  
                                </div>
                              </div>
                            </div>
                            <div className='col-md-6'>
                              <div className='form-group row'>
                                <label className='col-sm-3 col-form-label'>Duration</label>
                                <div className='col-sm-9'>
                                  <input
                                    onChange={onChangehandler}
                                    type='number'
                                    className='form-control'
                                    name='duration'
                                    value={packageForm?.duration}
                                    placeholder='Enter Duration'
                                    // onChange={onChangeHandle}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className='col-md-6'>
                            <div className='row'>
                              <div className='col-sm-3'>Status</div>
                              <div className='col-sm-9'>
                              <select name="status"
                                    value={packageForm?.status} onChange={onChangehandler} className='form-control'>
                                <option value="">Status</option>
                                <option value='active'>Active</option>
                                <option value='inactive'>In-Active</option>
                              </select>
                              </div>
                            </div>
                            </div>
                          </div>
                        <div className='card-footer'>
                          <div className='row float-right p-3'>
                            <button
                              onClick={onSaveHandler}
                              className='btn btn-grd-disabled mr-2'>
                              <i className='icofont icofont-save'></i> {Object.keys(dataEdit).length > 0 ? 'Update' : 'Save'}
                            </button>
                            {/* <Link to={'/CarDetail/CarModel'} className='btn btn-outline-dark'> */}
                              <button onClick={onCloseHandler}>

                                Cancel
                              </button>
                            {/* </Link> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}

export default PackageForm